import { SessionService } from 'app/services/session.service';
import { Component, OnInit, Input, HostBinding, SimpleChanges, OnChanges, EventEmitter, Output } from '@angular/core';
import { Router, UrlTree, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

//This class is extended by a few others
@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  standalone: false,
})
export class LinkComponent implements OnInit, OnChanges {
  @HostBinding('class.hideButton') hideButton = false;
  @Input() to: string;
  @Input() externaloverride: boolean;
  @Input() disabled: boolean;
  @Input() className: string;
  @Input() disableRoute: boolean;
  @Input() authcheck = false;
  @Input() download = false;
  @Input() docindexnav: boolean;
  @Input() linkmode = null;
  @Input() showchevron = false;
  @Output() preNavigate = new EventEmitter<void>();
  tree: UrlTree;
  url: string;
  template = 'external';
  redirectViaServer = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sessionService: SessionService,
    private location?: Location
  ) {}

  ngOnInit() {
    if (this.authcheck) {
      if (this.sessionService.getUserInfo() !== null) {
        this.hideButton = true;
        return;
      }
    }

    if (this.disableRoute || this.to === undefined || this.to === '') {
      this.template = 'noRoute';
      return;
    }

    if (typeof this.externaloverride === 'undefined') {
      if (this.to && this.to.trim().search(/(http|https|mailto):/) !== 0) {
        this.template = 'internal';
        this.processInternalLink();
      } else {
        if (this.to && this.to.trim().search(/(mailto):/) === 0) {
          this.template = 'newTab';
        }
      }
    } else if (!this.externaloverride) {
      if (this.to && this.to.trim().search(/(http|https):/) !== 0) {
        this.template = 'internal';
        this.processInternalLink();
      } else {
        this.template = 'falseInternal';
      }
    } else {
      this.template = 'newTab';
    }
  }

  public isLinkActive(url: string): boolean {
    if (this.tree.fragment) {
      return location.href.indexOf(`${url}#${this.tree.fragment}`) !== -1;
    } else {
      url = url.endsWith('/') ? url.slice(0, -1) : url;
      return this.location.isCurrentPathEqualTo(url);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.to) {
      this.processInternalLink();
    }
  }

  processInternalLink() {
    this.tree = this.router.parseUrl(this.to);
    this.url = '';

    if (this.tree.root.children.primary) {
      const route = this.tree.root.children.primary.toString();
      this.url = `/${route}`;
    }

    if (this.to) {
      if (this.to.indexOf('#') === 0) {
        this.url = `/${this.route.snapshot.url.map((o) => o.path).join('/')}`;
      }

      const setRedirectionType = (context) => {
        let currentLocation: 'docs' | 'devhub' = 'docs';
        let navigatingTo: 'docs' | 'devhub' = 'docs';

        const currentUrl = window.location.pathname;
        const currentSegments = currentUrl.split('/').filter(Boolean);
        if (currentSegments[0] === 'dashboard') {
          currentLocation = 'devhub';
        } else {
          currentLocation = 'docs';
        }

        const navigatingToSegments = context.to.split('/').filter(Boolean);
        if (navigatingToSegments[0] === 'dashboard') {
          navigatingTo = 'devhub';
        } else {
          navigatingTo = 'docs';
        }

        if (
          (currentLocation === 'devhub' && navigatingTo === 'docs') ||
          (currentLocation === 'docs' && navigatingTo === 'devhub')
        ) {
          context.redirectViaServer = true;
        } else {
          context.redirectViaServer = false;
        }
      };

      setRedirectionType(this);
    }
  }

  onPreNavigateClick(event: MouseEvent) {
    event.preventDefault();
    this.preNavigate.emit();
    if (this.template === 'internal') {
      this.router.navigate([this.to]);
      return;
    } else {
      window.open(this.to, '_blank');
      return;
    }
  }

  handleRedirect(event: MouseEvent, url: string) {
    event.preventDefault();
    if (url && url.includes('dashboard/logout')) {
      this.sessionService.logout();
    } else {
      window.location.href = url;
    }
  }

  handleClick() {
    const currentUrl = `/${this.route.snapshot.url.map((o) => o.path).join('/')}`;

    if (this.tree.fragment && currentUrl === this.url) {
      const element = document.getElementById(this.tree.fragment);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    const element = document.getElementById('closeHamburger');
    if (element) {
      element.click();
    }
  }
}